import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import StatusContainer from "../../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import { beneTxnSuccessDetail } from "../../../../redux/features/beneficiary/beneTxnAccounts/beneTransactionAccounts";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TEXT from "../../../../utils/globalText";

const BulkStatementSucess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [sucessData, setSucessData] = useState([]);
  const beneTxnSuccessDataError = useSelector(
    (state) => state.beneTransactionAccounts.beneTxnSuccessDataError,
  );

  useEffect(() => {
    const data = sessionStorage.getItem("uploadStatementData");
    setSucessData(JSON.parse(data));
  }, []);

  useEffect(() => {
    if (beneTxnSuccessDataError == "Request failed with status code 404") {
      navigate(
        `/beneficiary_transaction_dashboard/create_beneficiary_transaction/failed`,
      );
    }
  }, [beneTxnSuccessDataError]);

  useEffect(() => {
    dispatch(disableSwitcher());

    dispatch(beneTxnSuccessDetail(id));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(enableSwitcher());
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch, id]);

  const uploadBankStatement = () => {
    navigate("/owner_account_dashboard/upload_bulk_bank_statement");
    try {
      sessionStorage.removeItem("recreate_ben");
    } catch {}
  };

  const dashboardHandler = () => {
    navigate("/owner_account_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Upload bank statement",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: uploadBankStatement,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  return (
    <>
      <div className="mx-auto">
        <StatusContainer
          isLoading={false}
          status="success"
          hoverOption="white"
          title={"Statement is being processed"}
          subtitle="Once the data is uploaded, you will be notified by email, and it will be reflected in Xpentra’s statement."
          buttonRows={buttonRows}
        >
          <TabsWeapperSection title="Upload details">
            <>
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: formatAccountNumber(sucessData?.account_no),
                    leftSubTitle: "Bank Account Number",
                  },
                ]}
              />

              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: sucessData?.iFSC_Code,
                    leftSubTitle: TEXT?.IFSC_CODE,
                    ifsc: sucessData?.iFSC_Code,
                  },
                ]}
              />

              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      sucessData?.uploaded_file_data?.metadata?.filename,

                    leftSubTitle: "File name",
                  },
                ]}
              />
            </>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default BulkStatementSucess;
